import { render, staticRenderFns } from "./detail-flow.vue?vue&type=template&id=6f4589cd&scoped=true&"
import script from "./detail-flow.vue?vue&type=script&lang=js&"
export * from "./detail-flow.vue?vue&type=script&lang=js&"
import style0 from "./detail-flow.vue?vue&type=style&index=0&id=6f4589cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4589cd",
  null
  
)

export default component.exports